export default "__VITE_ASSET__BuWLJ0pn__"